import { BsLightning } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';
import { StyledNavButton } from '../styles/navStyles';

interface FeatureMenuButtonProps {
	toggleFunc: () => void;
}

const FeatureMenuButton = ({ toggleFunc }: FeatureMenuButtonProps) => {
	return (
		<BayTooltip overlay={<span>Product Updates</span>} placement="bottom">
			<StyledNavButton className="desktop-menu-icons" onClick={toggleFunc}>
				<BsLightning size={16} />
			</StyledNavButton>
		</BayTooltip>
	);
};

export default FeatureMenuButton;
